'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voting-show-ss.routes';

export class VotingShowSsComponent {
  constructor($stateParams, VotingsService, $uibModal, $window, DTOptionsBuilder, User, SettingsService, PropertyService,
              $location, VoterGroupsService, HistoryService, ClosingSnapshotsService, DTColumnBuilder, $timeout) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.voteId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$location = $location;
    this.$timeout = $timeout;

    this.quorum = 0;
    this.attended = 0;
    this.totalVotings = 0;
    this.propertiesWithProxies = 0;
    this.propertiesQuorum = 0;

    this.VotingsService = VotingsService;
    this.PropertyService = PropertyService;
    this.VoterGroupsService = VoterGroupsService;
    this.HistoryService = HistoryService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;

    this.DTColumnBuilder = DTColumnBuilder;
    this.DTOptionsBuilder = DTOptionsBuilder;

    this.dtOptionsBallots = DTOptionsBuilder
      .newOptions()
      .withOption('ordering', false);

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideUseBldgUnit = ssDT && ssDT.properties && ssDT.properties.useBldgUnit;

      SettingsService.getByName({name: 'client'}, settings => {
        this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
        this.quorumThreshold = settings.data.quorum || 0;
        this.useSuite = settings.data.useSuite;

        this.weightVisible = settings.data.weightVisible;
        this.hasBuildingNo = settings.data.buildingNoVisible;

        this.dtOptionsAttendance = DTOptionsBuilder
          .newOptions()
          .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

        this.dtOptionsProxy = DTOptionsBuilder
          .newOptions()
          .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

        this.refreshData();
      });
    });

    this.dtOptionsUpcoming = DTOptionsBuilder
      .newOptions()
      .withOption('rowGroup', [0])
      .withOption('columnDefs', [ {
        targets: [0],
        visible: false
      } ]);

    this.dtOptionsHistory = DTOptionsBuilder
      .newOptions()
      .withOption('order', [[0, 'desc']]);

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

  }

  getVotesPerBallot(ballotId, voting) {
    return [... new Set(voting.votes.filter(v => v.ballot == ballotId).map(v => this.isContactVoting ? v.contact : v.property))].length;
  }

  getPrimaryOwnerId(contacts) {
    if (!contacts) return 0;

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    if (!contacts) return 0;

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getContactName(contact) {
    if (!contact || (!contact.lastName && !contact.company))
      return "-";

    return this.getComposedName(contact);
  }

  updateProxy(voter, property, proxy) {
    this.VotingsService.updateProxy({id: this.vote._id, propertyId: property}, proxy);
  }

  updateAttendance(voter, property, attendance) {
    this.VotingsService.updateAttendance({id: this.vote._id, propertyId: property}, {value: attendance});
  }

  showResults(ballot, secret) {
    this.$location.url(`/voting/${this.vote._id}/ballot/result/${ballot._id}`);
  }

  adjustColumns(tableId) {
    this.$timeout(_=>{
      $('#'+ tableId).DataTable().columns.adjust();
    }, 0);
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.VotingsService.addAttachments({id: that.voteId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to contact');
        });
      },
      function () { /* cancel */ }
    );

  }

  refreshData() {
    this.quorum = 0;
    this.attended = 0;
    this.totalVotings = 0;
    this.propertiesWithProxies = 0;
    this.hasQuorum = 0;

    this.proxyTypes = [{
      name: "Write-in Proxy",
      type: "write-in"
    }];

    this.historyInit = false;
    this.dataInitComplete = false;

    if (this.voteId) {
      this.VotingsService.get({id: this.voteId}, data => {
        this.vote = data;

        this.maxHistory = this.vote.ballots.length + 1;
        this.currentHistory = 0;

        this.HistoryService.getByEntity({id: this.voteId}, data => {

          this.history = data.map(entry => {
            entry.context = this.vote.name;
            return entry;
          });

          this.currentHistory++;
          if (this.currentHistory == this.maxHistory) // in the strange case that there are no ballots, show at least the voting event history
            this.historyInit = true;

          this.vote.ballots.forEach(ballot => {
            this.HistoryService.getByEntity({id: ballot._id}, data => {
              this.history = this.history.concat(data.map(entry => {
                entry.context = ballot.name;
                return entry;
              }));

              this.currentHistory++;
              if (this.currentHistory == this.maxHistory)
                this.historyInit = true;
            });
          });
        });

        let processData = voterData => {
          this.voters = voterData;

          if (this.vote.defaultProxy && this.vote.defaultProxy.enabled && this.vote.defaultProxy.name) {
            this.proxyTypes.unshift({
              name: "Default Proxy",
              type: "default"
            });
          }

          let quorumMap = {};
          let quorumIds = this.voters.map(v => v._id);

          quorumIds.forEach(id => quorumMap[id] = 0);

          if (!this.isContactVoting) {

            this.vote.attendances.forEach(att => {
              let voter = this.voters
                .filter(u => u.eVoting && u.eVoting.voter && u.eVoting.voter._id)
                .find(u => u._id == att.property);
              //.find(u => u.eVoting.voter._id == att.voter && u._id == att.property);

              if (voter)
                voter.attended = att.attended;

              if (voter && voter.attended && quorumMap.hasOwnProperty(att.property)) {
                this.attended++;
                quorumMap[att.property]++;
              }
            });

            this.vote.proxies.forEach(prox => {
              let voter = this.voters
                .filter(u => u.eVoting && u.eVoting.voter && u.eVoting.voter._id)
                .find(u => u._id == prox.property);
              //.find(u => u.eVoting.voter._id == prox.voter && u._id == prox.property);

              if (voter) {
                voter.proxy = prox.proxy;

                if (!voter.proxy.enabled) return;

                if (quorumMap.hasOwnProperty(prox.property)) {
                  if (prox.proxy.type == 'default' || (prox.proxy.type == 'write-in' && prox.proxy.writeInProxyName && prox.proxy.writeInProxyApproved)) {
                    this.propertiesWithProxies++;
                    quorumMap[prox.property]++;
                  }
                }
              }

            });

            this.vote.votes.forEach(vote => {
              if (quorumMap.hasOwnProperty(vote.property)) {
                this.totalVotings++;
                quorumMap[vote.property]++;
              }
            });
          } else { // contact voting
            this.vote.votes.forEach(vote => {
              if (quorumMap.hasOwnProperty(vote.voter)) {
                this.totalVotings++;
                quorumMap[vote.voter]++;
              }
            });
          }

          Object.keys(quorumMap).forEach(id => {
            if (quorumMap[id]) {
              this.hasQuorum++;
            }
          });

          this.quorum = this.hasQuorum / this.voters.length;

          if (this.vote.state != 'closed')
            this.getServerSideData();

          this.dataInitComplete = true;
        };

        if (this.vote.state == 'closed' && this.vote.closingSnapshot) {
          this.ClosingSnapshotsService.get({id: this.vote.closingSnapshot}, snapshot => {
            this.snapshotDate = snapshot.meta.clientDate || snapshot.meta.creationDate;
            this.snapshot = snapshot;

            this.isContactVoting = this.snapshot && this.snapshot.type == 'contacts';
            processData(snapshot.data);
          });
        } else {
          let VG_QUERY_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
          this.VoterGroupsService[VG_QUERY_METHOD]({id: this.vote.voterGroup._id}, vg => {
            this.isContactVoting = this.vote.voterGroup && this.vote.voterGroup.type == 'contacts';
            let data = (this.isContactVoting) ? vg.contacts : vg.properties;
            processData(data);
          });
        }

      }, err => {
        console.log('Could not load vote from server');
      });
    }
  }

  getServerSideData() {
    const that = this;

    this.defaultOrder = (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'];
    if (this.serverSideUseBldgUnit)
      this.defaultOrder = [0, 'asc'];

    this.dtColumnsProxy = [];

    if (this.serverSideUseBldgUnit)
      this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("customFields.buildingUnit").withTitle('Bldg-Unit').withOption('width', '3%'));
    else if (this.hasBuildingNo) {
      this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("buildingNo").withTitle('Bldg#').withOption('width', '3%'));
      this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
    } else {
      this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
    }

    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("address").withTitle('Address').withOption('width', '20%'));
    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("voter").withTitle('Voter').withOption('width', '20%'));
    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("proxy").withTitle('Proxy').withOption('width', '15%'));
    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("type").withTitle('Type').withOption('width', '15%'));
    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("proxyHolder").withTitle('Proxy Holder').withOption('width', '15%'));
    this.dtColumnsProxy.push(this.DTColumnBuilder.newColumn("approved").withTitle('Approved').withOption('width', '15%'));

    this.dtOptionsProxySS = this.DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('pagingType', 'full_numbers')
      .withOption('order', this.defaultOrder)
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          //params.search.fields = ["properties.buildingNo", "properties.lotNo", "properties.address.street", "properties.customFields.buildingUnit", "properties.eVoting.voter.firstName", "properties.eVoting.voter.lastName"];
          params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit"];
        }

        that.VoterGroupsService.getWithDataSS({id: that.vote.voterGroup._id}, params, result => {

          that.ssProxyData = result.data.map(ppty => {
            let found = that.voters.find(o => o._id == ppty._id);
            if (found) {
              if (found.proxy) ppty.proxy = found.proxy;
            }
            return ppty;
          });

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtProxy').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtColumnsAttendance = [];

    if (this.serverSideUseBldgUnit)
      this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("customFields.buildingUnit").withTitle('Bldg-Unit').withOption('width', '3%'));
    else if (this.hasBuildingNo) {
      this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("buildingNo").withTitle('Bldg#').withOption('width', '3%'));
      this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
    } else {
      this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
    }

    this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("address").withTitle('Address').withOption('width', '20%'));
    this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("primaryOwner").withTitle('Primary Owner').withOption('width', '20%'));
    this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("otherOwner").withTitle('Other Owner').withOption('width', '20%'));
    this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("voter").withTitle('Voter').withOption('width', '20%'));
    this.dtColumnsAttendance.push(this.DTColumnBuilder.newColumn("attendance").withTitle('Att.').withOption('width', '3%'));

    this.dtOptionsAttendanceSS = this.DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('pagingType', 'full_numbers')
      .withOption('order', this.defaultOrder)
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          //params.search.fields = ["properties.buildingNo", "properties.lotNo", "properties.address.street", "properties.customFields.buildingUnit", "properties.eVoting.voter.firstName", "properties.eVoting.voter.lastName"];
          params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit"];
        }

        that.VoterGroupsService.getWithDataSS({id: that.vote.voterGroup._id}, params, result => {

          that.ssAttendanceData = result.data.map(ppty => {
            let found = that.voters.find(o => o._id == ppty._id);
            if (found) {
              if (found.attended) ppty.attended = found.attended;
            }
            return ppty;
          });

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtAttendance').DataTable().columns.adjust();
          }, 0);
        })
      });
  }

}

export default angular.module('conduu.votingShowSS', [uiRouter])
  .config(routes)
  .component('votingShowSs', {
    template: require('./voting-show-ss.html'),
    controller: VotingShowSsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voting/voting-show-ss/voting-show-ss.component.js